import script from "./ConfigurationBody.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationBody.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationBody.vue?vue&type=style&index=0&id=6caf099f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6caf099f"]])

export default __exports__